import { toBoolean } from 'pages/utils/sanitize';
import {
  InventoryCountDTO,
  InventoryCountDTOServer,
} from 'root/apps/InventoryCountReconcile/types';

export const parseInventoryCountDTOServer: (dto: InventoryCountDTOServer) => InventoryCountDTO = (
  dto
) => {
  const newDTO: InventoryCountDTO = {
    ...dto,
    totalBatches: parseInt(dto.totalBatches, 10),
    totalErrors: parseInt(dto.totalErrors, 10),
    totalSuccess: parseInt(dto.totalSuccess, 10),
    progress: parseInt(dto.progress, 10),
    archived: toBoolean(dto.archived),
  };
  return newDTO;
};
